import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";
import { Glyphicon } from "react-bootstrap";

import "./FeatureOverview.css";

export default class FeatureOverview extends Component {

  constructor(props) {
    super();

    this.state = {
    };
  }

  render() {
    var style = {
    }
    var width = (window.innerWidth);
    if (width >= 960) {
      style['width']= 960;
      style['marginLeft']='auto';
      style['marginRight']='auto';
    }
    return (
      <Grid className="FeatureOverview">
        <h1>
          Features
        </h1>
        <Row style={style}>
          <Col className="column" xs={4} sm={4} md={4} lg={4}>
            <Glyphicon glyph="pencil" />
            <h4>
              custom habit schedule
            </h4>
            <p>
              Customize your habit table just the way you want it. Do habits only on the days you wan
            </p>
          </Col>
          <Col className="column" xs={4} sm={4} md={4} lg={4}>
            <Glyphicon glyph="eye-open" />
            <h4>
              visualize your progress
            </h4>
            <p>
              See your trends over time, set records, and celebrate your growth
            </p>
          </Col>
          <Col className="column" xs={4} sm={4} md={4} lg={4}>
            <Glyphicon glyph="pushpin" />
            <h4>
              receive reminders
            </h4>
            <p>
              Receive push updates, via text, email, and alexa
            </p>
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FeatureOverview.js